import React, { FC } from 'react'

import { TrackingRecoSectionContext } from '@aboutyou/legacy-tracking-sdk'
import BrandTile from 'components/BrandTile'
import Carousel from 'components/Carousel'
import { RecoSliderSectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import { useService } from 'services/utils/context'
import styled from 'styled-components'
import { fsM, fsXS, fwLight } from 'uiComponents/constants/typography'
interface BrandSliderProps {
  brandIds: string[]
  ctaText?: string
  headline?: string
  slidesToScroll: number
  slidesToShow: number
  subline?: string
  withRectangle?: boolean
  recoType: TrackingRecoSectionContext['recoType']
}

const Tile = styled.div`
  padding: 0;
  margin: 0;
`

const BrandSliderCarousel: FC<{
  brandIds: string[]
  slidesToScroll: number
  slidesToShow: number
  withRectangle?: boolean
}> = ({ brandIds, withRectangle, slidesToScroll, slidesToShow }) => {
  const service = useService()
  const filteredBrandIds = brandIds.filter(id =>
    Boolean(service.brands.getByBrandId(id)),
  )

  if (!filteredBrandIds.length) {
    return null
  }

  const brandTiles = filteredBrandIds.map((id: string, index: number) => {
    return (
      <Tile key={index}>
        <BrandTile brandId={id} withRectangle={withRectangle} />
      </Tile>
    )
  })

  return (
    <Carousel
      slidesToShow={slidesToShow}
      slidesToScroll={slidesToScroll}
      alignLeft
      key={brandIds.join()}
    >
      {brandTiles}
    </Carousel>
  )
}

const Container = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 52px;
`

const Subline = styled.h3`
  font-size: ${fsXS}px;
  ${fwLight}
  line-height: 1.54;
`

const Headline = styled.h2`
  font-size: ${fsM}px;
  ${fwLight}
  line-height: 1.4;
  margin-bottom: 19px;
`

const CTA = styled.div`
  cursor: pointer;
  margin-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;

  &:hover {
    text-decoration: underline;
  }
`

const BrandSlider: FC<BrandSliderProps> = props => {
  const {
    brandIds,
    headline,
    subline,
    ctaText,
    recoType,
    withRectangle,
    slidesToScroll,
    slidesToShow,
  } = props

  return (
    <RecoSliderSectionTrackingContextProvider
      headline={headline}
      recoType={recoType}
    >
      <Container data-testid="BrandSlider">
        {(ctaText || headline) && (
          <div className="row bottom-sm">
            {headline && (
              <div className="col-sm-6">
                {subline && <Subline>{subline}</Subline>}
                {headline && <Headline>{headline}</Headline>}
              </div>
            )}
            <CTA className="col-sm-6">{ctaText}</CTA>
          </div>
        )}
        <BrandSliderCarousel
          brandIds={brandIds}
          withRectangle={withRectangle}
          slidesToScroll={slidesToScroll}
          slidesToShow={slidesToShow}
        />
      </Container>
    </RecoSliderSectionTrackingContextProvider>
  )
}

export default BrandSlider
